import {
    Directive,
    Input,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from 'app/core/user/user.service';
import { environment } from 'enviroments/environment';

@Directive({
    selector: '[appControlAcceso]',
    standalone: true,
})
export class ControlAccesoDirective implements OnInit, OnDestroy {
    private suscripcionUsuario?: Subscription;
    private rolUsuarioActual: string | null = null;
    private rolesNoPermitidos: string[] | null = null;

    constructor(
        private plantillaRef: TemplateRef<any>,
        private contenedorVista: ViewContainerRef,
        private servicioUsuario: UserService
    ) {}


    @Input()
    set appControlAcceso(regla: string | null | undefined) {
        const clave = (regla || '').trim();

        switch (clave) {
            case 'lectura':
            default:
                this.rolesNoPermitidos = [String(environment.TIPOLOGIA_ID_LECTOR)];
                break;
        }

        this.aplicarVisibilidad();
    }

    ngOnInit(): void {
        this.suscripcionUsuario = this.servicioUsuario.usuarioLogueado$.subscribe(
            (usuario) => {
                this.rolUsuarioActual = usuario ? String(usuario.rol_id) : null;
                this.aplicarVisibilidad();
            }
        );
    }

    ngOnDestroy(): void {
        this.suscripcionUsuario?.unsubscribe();
    }

    private aplicarVisibilidad(): void {
        this.contenedorVista.clear();

        if (!this.rolUsuarioActual) {
            return;
        }

        const rolesNoPermitidos = this.rolesNoPermitidos ?? [];

        if (!rolesNoPermitidos.length) {
            this.contenedorVista.createEmbeddedView(this.plantillaRef);
            return;
        }

        const rolBloqueado = rolesNoPermitidos.includes(this.rolUsuarioActual);

        if (!rolBloqueado) {
            this.contenedorVista.createEmbeddedView(this.plantillaRef);
        }
    }
}
